/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import _ from 'lodash';
import transitions from 'material-ui/styles/transitions';
import shallowEqual from 'fbjs/lib/shallowEqual';
export const styles = {};
export default class ChildrenFader extends PureComponent {

  constructor(props) {
    super(props);
    const {visible, children} = props;
    this.state = {
      additionalStyle: visible ? {} : this.getEnterStyle(props),
      children: children,
      renderChildren: visible,
      readyToEnter: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const {transitionDurationMs, hiddenStyle} = nextProps;
    const nextChildren = nextProps.children;
    if (this.props.path !== nextProps.path) {
      this.clearTimeouts();
      this.setState({additionalStyle: this.getLeaveStyle(nextProps)});
      this.transitioning = true;
      this.pendingChildren = nextChildren;
      this.timeout = window.setTimeout(() => {
        if (this.timeout === null) {
          return;
        }
        this.clearTimeouts();
        this.setState({
          children: this.pendingChildren,
          readyToEnter: true,
          additionalStyle: this.getEnterStyle(),
        });
      }, transitionDurationMs);
    } else if (this.props.visible !== nextProps.visible) {
      this.clearTimeouts();
      const immediateUpdate = nextProps.visible ? {renderChildren: true, additionalStyle: {}, children: nextChildren} : {additionalStyle: hiddenStyle};
      const delayedUpdate = nextProps.visible ? {} : {children: nextChildren, renderChildren: false};
      const hideDelayMs = nextProps.visible ? 0 : this.props.hideDelayMs;
      this.timeout = window.setTimeout(() => {
        if (this.timeout === null) {
          return;
        }
        this.clearTimeouts();
        this.setState(immediateUpdate);
        this.timeout = window.setTimeout(() => {
          if (this.timeout === null) {
            return;
          }
          this.clearTimeouts();
          this.setState(delayedUpdate);
        }, transitionDurationMs);
      }, hideDelayMs);
    } else {
      if (this.transitioning) {
        this.pendingChildren = nextChildren;
      } else {
        this.setState({
          children: nextChildren,
        });
      }
    }
  }

  componentDidUpdate() {
    const {enterDelayMs} = this.props;
    const {readyToEnter} = this.state;
    if (readyToEnter) {
      this.deferTimeout = window.setTimeout(() => {
        if (this.deferTimeout === null) {
          return;
        }
        this.clearTimeouts();
        this.setState({additionalStyle: {}, readyToEnter: false});
      }, Math.max(15, enterDelayMs));
    }
  }

  componentWillUnmount() {
    this.clearTimeouts();
  }

  getEnterStyle = (props = this.props) => {
    const {hiddenStyle, enterStyle} = props;
    return enterStyle || hiddenStyle;
  };

  getLeaveStyle = (props = this.props) => {
    const {hiddenStyle, leaveStyle} = props;
    return leaveStyle || hiddenStyle;
  };

  clearTimeouts = () => {
    this.transitioning = false;
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (this.deferTimeout) {
      window.clearTimeout(this.deferTimeout);
      this.deferTimeout = null;
    }
  };

  render() {
    const {children: childrenFromProps, hiddenStyle, style, transitionDurationMs, path, visible, hideDelayMs, leaveStyle, enterStyle, debug, enterDelayMs, ...props} = this.props;
    const {children, additionalStyle, renderChildren} = this.state;
    const rootStyle = {
      transition: transitions.easeOut(`${transitionDurationMs}ms`),
      ...style,
      ...additionalStyle,
    };
    return (
      <div
        {...props}
        style={rootStyle}
      >
        {
          renderChildren && children
        }
      </div>
    );
  }
}

ChildrenFader.propTypes = {
  transitionDurationMs: PropTypes.number.isRequired,
  path: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  hiddenStyle: PropTypes.object.isRequired,
  leaveStyle: PropTypes.object,
  enterStyle: PropTypes.object,
  hideDelayMs: PropTypes.number.isRequired,
  enterDelayMs: PropTypes.number.isRequired,
};

ChildrenFader.defaultProps = {
  transitionDurationMs: 150,
  visible: true,
  hiddenStyle: {opacity: 0},
  hideDelayMs: 0,
  enterDelayMs: 0,
};